module.exports = __webpack_public_path__ + "static/media/picture.d4c79fcd.svg";